/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryResponse, PntSegmentsControllerGetSegmentsFaceRecognitionsByDatePathParams, PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryParams } from "../models/PntSegmentsControllerGetSegmentsFaceRecognitionsByDate";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { pntSegmentsControllerGetSegmentsFaceRecognitionsByDate } from "../axios/pntSegmentsControllerGetSegmentsFaceRecognitionsByDate";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const pntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryKey = (slug: PntSegmentsControllerGetSegmentsFaceRecognitionsByDatePathParams["slug"], params: PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryParams) => ["api-v2", { url: '/pnt/v2/segments/:slug/facerecognition', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryKey = ReturnType<typeof pntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryKey>

export function pntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryOptions(slug: PntSegmentsControllerGetSegmentsFaceRecognitionsByDatePathParams["slug"], params: PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryKey(slug, params)
        return queryOptions<PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryResponse, ResponseErrorConfig<Error>, PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryResponse, typeof queryKey>({
         enabled: !!(slug&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return pntSegmentsControllerGetSegmentsFaceRecognitionsByDate(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve the face recognitions for a given time range
 * {@link /pnt/v2/segments/:slug/facerecognition}
 */
export function usePntSegmentsControllerGetSegmentsFaceRecognitionsByDate<TData = PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryResponse, TQueryData = PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryResponse, TQueryKey extends QueryKey = PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryKey>(slug: PntSegmentsControllerGetSegmentsFaceRecognitionsByDatePathParams["slug"], params: PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? pntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryKey(slug, params)
         

         const query = useQuery({
          ...pntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}